import { render, staticRenderFns } from "./AssetClassMethodology.vue?vue&type=template&id=273dd264&"
import script from "./AssetClassMethodology.vue?vue&type=script&lang=js&"
export * from "./AssetClassMethodology.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports